import styled from "@emotion/styled";

import { Flex, Text } from "../../styles/utility-components";
import { FilterableSavedViews } from "./FilterableSavedViews";

const SavedSearches = () => {
  return (
    <Flex column width="100%">
      <Header justifyContent="space-between" alignItems="center" gap="24px">
        <Text h2>Saved searches</Text>
      </Header>
      <Body column width="100%" gap="24px">
        <FilterableSavedViews defaultFilters={{}} />
      </Body>
    </Flex>
  );
};

const Header = styled(Flex)(({ theme }) => ({
  padding: "24px",
  borderBottom: `1px solid ${theme.colors.sysBorderDecorative}`,
}));

const Body = styled(Flex)({
  padding: "24px",
});

export default SavedSearches;
